import { getAppFromSpaWrapper, getEnvVar } from "@/utils";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import * as Sentry from "@sentry/vue";
import i18n from "@/i18n";
import { createVfm } from "vue-final-modal";
import { tripAdvisorErrorHandler } from "@/utils/promos-utils";
import { addSpaStaticsToHead } from "./utils/spa-statics";

addSpaStaticsToHead();

window.addEventListener("message", tripAdvisorErrorHandler, false);

const app = createApp(App);

// sentry
const SHOULD_SEND_SENTRY = getEnvVar("VITE_SENTRY_SHOULD_SEND") === "true";
if (SHOULD_SEND_SENTRY) {
  /*global __APP_BUILD__ */
  /*eslint no-undef: "error"*/
  // @ts-expect-error: TS2304 Need the global var
  const release: string = __APP_BUILD__;
  const dsn = getEnvVar("VITE_SENTRY_DSN");
  const environment = getEnvVar("VITE_SENTRY_ENVIRONMENT");
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/sampling/#sampling-error-events
  const sampleRate = parseFloat(getEnvVar("VITE_SENTRY_SAMPLE_RATE"));
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/sampling/#sampling-transaction-events
  const tracesSampleRate = parseFloat(
    getEnvVar("VITE_SENTRY_TRACES_SAMPLE_RATE")
  );
  // https://docs.sentry.io/platforms/javascript/guides/vue/session-replay/#sampling
  const replaysSessionSampleRate = parseFloat(
    getEnvVar("VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE")
  );
  const replaysOnErrorSampleRate = parseFloat(
    getEnvVar("VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE")
  );

  const tracingDomain = getEnvVar("VITE_SENTRY_BASEURL").split(".").join("\\.");

  const integrations = [
    Sentry.browserTracingIntegration({
      router,
    }),
  ];

  const SHOULD_REPLAY_SENTRY =
    getEnvVar("VITE_SENTRY_SHOULD_REPLAY") === "true";

  if (SHOULD_REPLAY_SENTRY) {
    // https://docs.sentry.io/platforms/javascript/guides/ember/session-replay/configuration/#mutation-limits
    const mutationLimit = getEnvVar("VITE_SENTRY_REPLAY_MUTATION_LIMIT");
    integrations.push(
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
        mutationLimit,
      })
    );
  }

  Sentry.init({
    app,
    dsn,
    environment,
    release,
    integrations,

    // Session Replay
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    // Sampling Error Events
    sampleRate,
    // Sampling Transaction Events
    tracesSampleRate,
    ignoreErrors: [
      // Instagram error that Meta isn't fixing but is not impacting users
      // See https://developers.facebook.com/community/threads/320013549791141/
      "_AutofillCallbackHandler",
    ],
    tracePropagationTargets: [new RegExp(`^https://${tracingDomain}/`)],
  });
}

// plugins
app.use(i18n);
app.use(createPinia());
app.use(router);
app.use(createVfm());

const appFromSpaWrapper = getAppFromSpaWrapper();

if (appFromSpaWrapper) {
  app.mount(appFromSpaWrapper);
} else {
  app.mount("#app");
}
